package org.hs_soft.runmynesto.di.options

import org.hs_soft.runmynesto.domain.usecase.home.SaveLanguageUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_flow.GetAppConfigUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_flow.UpdateAppConfigUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_register_config.ApaleoPropertiesUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_register_config.AydenStoresUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_register_config.CreateCashRegisterUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_register_config.CreateNewDepartmentUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_register_config.CreateNewRegionUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_register_config.CreateNewShopUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_register_config.GetCashRegisterConfigUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_register_config.TSELocationsUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_register_config.UpdateCashRegisterConfigUseCase
import org.hs_soft.runmynesto.domain.usecase.options.export.ApaleoPaymentMethodsUseCase
import org.hs_soft.runmynesto.domain.usecase.options.export.ApaleoSubAccountsUseCase
import org.hs_soft.runmynesto.domain.usecase.options.export.CashRegisterGlobalUseCase
import org.hs_soft.runmynesto.domain.usecase.options.export.OptionCreditCardUseCase
import org.hs_soft.runmynesto.domain.usecase.options.export.UpdateCashRegisterGlobalUseCase
import org.hs_soft.runmynesto.domain.usecase.options.printer_locatoin.UpdatePrinterLocationUseCase
import org.hs_soft.runmynesto.domain.usecase.options.menu_card_import.GetMenuCardUseCase
import org.hs_soft.runmynesto.domain.usecase.options.menu_card_import.UpsertProductsUseCase
import org.hs_soft.runmynesto.domain.usecase.options.operation.OptionDataUseCase
import org.hs_soft.runmynesto.domain.usecase.options.operation.UpdateOptionUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.CreateFloorUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.CreateFurnitureUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.CreateRoomUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.DeleteFloorUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.DeleteFurnitureUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.DeleteRoomUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.RestaurantProjectsUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.UpdateFloorUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.UpdateFurnitureUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.UpdateRestaurantProjectUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.UpdateRoomUseCase
import org.hs_soft.runmynesto.domain.usecase.options.sales_group.AddNewSaleGroupUseCase
import org.hs_soft.runmynesto.domain.usecase.options.sales_group.SingleSaleGroupUseCase
import org.hs_soft.runmynesto.domain.usecase.options.sales_group.UpdateSaleGroupUseCase
import org.hs_soft.runmynesto.domain.usecase.options.virtual_card.GetVirtualCardInfoUseCase
import org.hs_soft.runmynesto.domain.usecase.options.virtual_card.UpdateVirtualCardInfoUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_click_collect.UpdateProductPropertiesUseCase
import org.hs_soft.runmynesto.domain.usecase.template.AddCategoryUseCase
import org.hs_soft.runmynesto.domain.usecase.template.GetTemplateCategoriesUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_register_config.ListDeviceUseCase
import org.hs_soft.runmynesto.domain.usecase.options.price_category.UpdatePriceCategoriesUseCase
import org.koin.dsl.module

val optionsUseCaseModule= module {

    single {
        UpdatePriceCategoriesUseCase(get())
    }
    single {
        AydenStoresUseCase(get())
    }
    single {
        ApaleoPropertiesUseCase(get())
    }
    single {
        CreateCashRegisterUseCase(get())
    }
    single {
        CreateNewShopUseCase(get())
    }
    single {
        CreateNewRegionUseCase(get())
    }
    single {
        CreateNewDepartmentUseCase(get())
    }
    single {
        UpdatePrinterLocationUseCase(get())
    }

    single {
        OptionDataUseCase(get())
    }
    single {
        AddNewSaleGroupUseCase(get())
    }
    single {
        SingleSaleGroupUseCase(get())
    }
    single {
        UpdateSaleGroupUseCase(get())
    }

    single {
        UpdateOptionUseCase(get())
    }

    single {
        UpdateVirtualCardInfoUseCase(get())
    }

    single {
        GetAppConfigUseCase(get())
    }

    single {
        UpdateAppConfigUseCase(get())
    }
    single {
        GetCashRegisterConfigUseCase(get())
    }
    single {
        UpdateCashRegisterConfigUseCase(get())
    }

    single {
        GetVirtualCardInfoUseCase(get())
    }

    single {
        GetMenuCardUseCase(get())
    }
    single {
        RestaurantProjectsUseCase(get())
    }
    single {
        CreateFurnitureUseCase(get())
    }
    single {
        UpdateFurnitureUseCase(get())
    }
    single {
        CreateFloorUseCase(get())
    }
    single {
        UpdateFloorUseCase(get())
    }

    single {
        GetVirtualCardInfoUseCase(get())
    }
    single {
        DeleteFloorUseCase(get())
    }
    single {
        DeleteRoomUseCase(get())
    }
    single {
        UpsertProductsUseCase(get())
    }

    single {
        AddCategoryUseCase(get())
    }

    single {
        UpdateProductPropertiesUseCase(get())
    }
    single {
        CreateRoomUseCase(get())
    }
    single {
        UpdateRoomUseCase(get())
    }
    single {
        UpdateRestaurantProjectUseCase(get())
    }
    single {
        DeleteFurnitureUseCase(get())
    }
    single {
        GetCashRegisterConfigUseCase(get())
    }
    single {
        SaveLanguageUseCase(get())
    }

    single {
        GetTemplateCategoriesUseCase(get())
    }

    single {
        ApaleoPaymentMethodsUseCase(get())
    }

    single {
        OptionCreditCardUseCase(get())
    }

    single {
        CashRegisterGlobalUseCase(get())
    }

    single {
        UpdateCashRegisterGlobalUseCase(get())
    }

    single {
        ApaleoSubAccountsUseCase(get())
    }

    single {
        TSELocationsUseCase(get())
    }

    single {
        ListDeviceUseCase(get())
    }

}